<template>
  <div>
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-center text-primary" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">{{ $t("extras.loading") }}</span>
      </div>
    </div>
    <div v-else>
      <h2>{{ $t("extras.title") }}</h2>
      <hr>
      <div role="tablist">
        <b-card v-for="extra in extras" :key="extra.hash" no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle="extra.hash" variant="primary">
              {{ extra.category }}
              <span class="when-opened">
                <font-awesome-icon icon="chevron-right" />
              </span>
              <span class="when-closed">
                <font-awesome-icon icon="chevron-down" />
              </span>
            </b-button>
          </b-card-header>
          <b-collapse :id="extra.hash" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <ul style="list-style-type: none; padding: 0;">
                    <li  v-for="data in extra.data" :key="data.id" class="border border-secondary mb-2 p-3">
                      <div class="media">
                        <div class="image-box mr-3 rounded-circle border border-primary overflow-hidden">
                          <img :src="data.image" style="height:100%;">
                        </div>
                        <div class="media-body">
                          <h5 class="mt-0">{{data.name}}</h5>
                          {{data.description}}
                        </div>
                      </div>
                      <hr/>
                      <div class="text-center">
                        <strong class="mb-0">
                            $ {{data.price}} {{form.currency}} {{ $t("extras.each") }}
                        </strong><br>
                        <small>{{ $t("extras.taxes") }}</small>
                      </div>
                      <div class="row text-center">
                        <div class="col">
                          <label>{{ $t("extras.first") }}</label>
                          <div>
                            <button :key="'b'+data.id" v-on:click="removeExtra(data, 1)" type="button" class="btn btn-primary btn-sm rounded-circle"><font-awesome-icon icon="minus" /></button>
                            <span class="h4 ml-2 mr-2" :key="'g'+data.id">{{ getExtraById(data, 1) }}</span>
                            <button v-on:click="addExtra(data, 1)" type="button" class="btn btn-primary btn-sm rounded-circle"><font-awesome-icon icon="plus" /></button>
                          </div>
                        </div>
                        <div v-if="form.tripType=='roundTrip'" class="col">
                          <label>{{ $t("extras.second") }}</label>
                          <div>
                            <button v-on:click="removeExtra(data, 2)" type="button" class="btn btn-primary btn-sm rounded-circle"><font-awesome-icon icon="minus" /></button>
                            <span class="h4 ml-2 mr-2">{{ getExtraById(data, 2) }}</span>
                            <button v-on:click="addExtra(data, 2)" type="button" class="btn btn-primary btn-sm rounded-circle"><font-awesome-icon icon="plus" /></button>
                          </div>
                        </div>
                      </div>
                      <p class="text-right mb-0"><strong></strong></p>
                    </li>
                  </ul>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <Navigation></Navigation>
  </div>
</template>

<style>
  .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Navigation from './Navigation.vue'

export default {
  name: 'Extras',
  components: {
    Navigation
  },
  props: {
  },
  data: () => {
  	return {
    	extraSelectedTrip1: 0,
    	extraSelectedTrip2: 0,
      loading: true,
      extras: []
  	}
  },
  computed: {
    ...mapState(['form']),
    ...mapGetters(['getExtraById'])
  },
  methods: {
    ...mapMutations(['extrasById']),
    removeExtra(extra, trip) {
      let quantity = this.getExtraById(extra, trip);
      if (quantity > 0) {
        quantity--;
        this.extrasById({extra, trip, quantity});
      }
    },
    addExtra(extra, trip) {
      let quantity = this.getExtraById(extra, trip);
      if (quantity < extra.maxPerService) {
        quantity++;
        this.extrasById({extra, trip, quantity});
      }
    },
    orderExtras(extras){
      let items = {};
      for( let i =0; i < extras.length; i++ ){
        var category = extras[i].categoryName.replace(/\s/g,'') ;
        if( !items[category] ){
          items[category] = [] ;
        }
        items[category].push(extras[i]);
      }
      let myArray = [];
      for( var category in items ){
        myArray.push({'hash': category, 'category': items[category][0].categoryName,'data': items[category] });
      }
      return myArray;
    }
  },
  mounted() {
    this.$http.get('extras/list', {params: {currency: this.form.currency}})
    .then((res) => {
      this.extras = this.orderExtras(res.body);
      this.loading = false;
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.media-body{
		font-size: 14px;
		line-height: 16px;
	}
  .image-box{
    width: 100px;
    height: 100px;
  }
	.media img{
		max-width: 100%;
    height:auto;
	}
</style>
